import { Grid, Typography } from "../../../../components";

const PreviewEtiquetaTab = ({
  etiqueta,
  produto,
  dimensoes,
  mmToPx,
  labelElements,
  getEplFontSize,
  renderText,
  BarcodePreview,
  TYPECODE,
}) => {
  function PreviewEtiquetas({
    dimensoes,
    etiqueta,
    labelElements,
    mmToPx,
    getEplFontSize,
    renderText,
  }) {
    const {
      larguraEtiquetaPx,
      alturaEtiquetaPx,
      margemLateralPx,
      margemMeioPx,
    } = dimensoes;
    const colunas = etiqueta?.colunasEtiqueta || 1;

    const paddingPaiPx = mmToPx(2.5);
    const etiquetas = Array.from({ length: colunas });

    return (
      <div
        className="rounded-4"
        style={{
          backgroundColor: "#f9f9f9",
          padding: `0 ${margemLateralPx}px`,
          display: "grid",
          gridTemplateColumns: `repeat(${colunas}, auto)`,
          gap: `${margemMeioPx}px`,
          justifyContent: "center",
          border: "2px solid #ccc",
          margin: "0 auto",
        }}
      >
        {etiquetas.map((_, index) => (
          <div
            key={index}
            className="etiqueta-preview-externa rounded-3"
            style={{
              backgroundColor: "#FFFFFF",
              border: "1px solid #eee",
              width: `${
                (larguraEtiquetaPx - margemMeioPx - margemLateralPx) / colunas
              }px`,
              height: `${alturaEtiquetaPx}px`,
              position: "relative",
              boxSizing: "border-box",
              overflow: "hidden",
              padding: `${paddingPaiPx}px`,
            }}
          >
            <div
              className="etiqueta-preview-interna"
              style={{
                backgroundColor: "#FFFFFF",
                width: "100%",
                height: "100%",
                boxSizing: "border-box",
                position: "relative",
              }}
            >
              {labelElements.map((label) => (
                <div
                  key={label.id}
                  style={{
                    position: "absolute",
                    left: `${label.x}px`,
                    top: `${label.y}px`,
                    fontSize: `${getEplFontSize(label.fontSize)}px`,
                    fontFamily: "Inconsolata, monospace",
                    fontWeight: 700,
                    textAlign: label.align || "left",
                    whiteSpace: "nowrap",
                    overflow: "hidden",
                    userSelect: "none",
                  }}
                >
                  {label.codeType ? (
                    <BarcodePreview
                      value={produto[label.elemento] || ""}
                      key={label.elemento}
                      type={TYPECODE[label.codeType]}
                      height={label.codeHeight || 80}
                      width={label.codeWidth || 8}
                      fontSize={getEplFontSize(label.fontSize)}
                      showValue={label.showLabelCode}
                    />
                  ) : (
                    <span
                      style={{
                        overflowWrap: "anywhere",
                        height: label.height,
                      }}
                    >
                      {renderText(
                        label.fontSize,
                        produto[label.elemento],
                        label.elemento
                      )}
                    </span>
                  )}
                </div>
              ))}
            </div>
          </div>
        ))}
      </div>
    );
  }
  return (
    <Grid
      item
      xs={12}
      direction="column"
      className="w-100 d-flex align-items-center mt-5"
    >
      <Typography variant="body2" gutterBottom sx={{ mb: 2 }}>
        Visualização completa da folha de etiquetas
      </Typography>
      <PreviewEtiquetas
        dimensoes={dimensoes}
        etiqueta={etiqueta}
        labelElements={labelElements}
        mmToPx={mmToPx}
        getEplFontSize={getEplFontSize}
        renderText={renderText}
      />
    </Grid>
  );
};

export default PreviewEtiquetaTab;
